var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('Header'),_c('Bread'),(_vm.select === 1)?_c('Shipment',{staticStyle:{"margin-top":"10px"}}):_vm._e(),(_vm.select === 2)?_c('Production',{staticStyle:{"margin-top":"10px"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }